export default __webpack_public_path__ + "static/HelpScout-31ab8333e68efeb321b458fa840bb954.png";